(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  class CollectionGridSlider extends HTMLElement {
    #abortController = new AbortController();
    #resizeObserver = new ResizeObserver(() => this.#update());

    connectedCallback() {
      const track = this.querySelector('[data-collection-grid-track]');
      if (!(track instanceof HTMLElement)) return;

      const { signal } = this.#abortController;
      track.addEventListener('scroll', () => this.#update(), { passive: true, signal });
      this.querySelector('[data-collection-grid-prev]')?.addEventListener('click', () => this.#page(-1), { signal });
      this.querySelector('[data-collection-grid-next]')?.addEventListener('click', () => this.#page(1), { signal });
      this.#resizeObserver.observe(track);
      this.#update();
    }

    disconnectedCallback() {
      this.#abortController.abort();
      this.#resizeObserver.disconnect();
    }

    get #track() {
      return this.querySelector('[data-collection-grid-track]');
    }

    /** @param {number} direction */
    #page(direction) {
      const track = this.#track;
      if (!(track instanceof HTMLElement)) return;
      track.scrollBy({ left: direction * track.clientWidth });
    }

    #update() {
      const track = this.#track;
      if (!(track instanceof HTMLElement)) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const prev = this.querySelector('[data-collection-grid-prev]');
      const next = this.querySelector('[data-collection-grid-next]');
      if (prev instanceof HTMLElement) prev.hidden = maxScroll <= 1 || track.scrollLeft <= 1;
      if (next instanceof HTMLElement) next.hidden = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('collection-grid-slider')) {
    customElements.define('collection-grid-slider', CollectionGridSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-rotator')) {
    class HeroRotator extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-rotator__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        this.interval = Number(this.dataset.interval) || 0;
        this.timer = 0;
        this.drag = null;
        this.suppressClick = false;
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.onDesktopChange = () => this.show(this.index);
        this.desktopQuery.addEventListener('change', this.onDesktopChange);
        this.onPointerMove = (event) => {
          if (!this.drag || event.pointerId !== this.drag.pointerId) return;
          this.drag.lastX = event.clientX;
          this.drag.lastY = event.clientY;
        };
        this.onPointerRelease = (event) => {
          if (this.drag && event.pointerId !== this.drag.pointerId) return;
          if (event.type === 'pointercancel' && event.pointerType !== 'mouse') {
            const drag = this.drag;
            this.stopPointerWatch();
            window.clearTimeout(this.cancelTimer);
            this.cancelTimer = window.setTimeout(() => {
              this.cancelTimer = 0;
              if (!drag || this.drag !== drag) return;
              this.finishDrag(drag.lastX, drag.lastY);
            }, 80);
            return;
          }
          const drag = this.drag;
          this.stopPointerWatch();
          if (!drag) return;
          this.finishDrag(event.clientX, event.clientY);
        };

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.show(index);
            this.queue();
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.queue());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.queue();
        });
        this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.addEventListener('dragstart', (event) => {
          if (event.target.closest('a, button')) return;
          event.preventDefault();
        });
        this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
        this.addEventListener('touchmove', (event) => this.onTouchMove(event), { passive: false });
        this.addEventListener('touchend', (event) => this.onTouchEnd(event));
        this.addEventListener('touchcancel', (event) => this.onTouchEnd(event));
        this.addEventListener(
          'click',
          (event) => {
            if (!this.suppressClick) return;
            const onDot = event.target.closest('.hero-rotator__dots, [data-hero-dot]');
            this.suppressClick = false;
            if (onDot) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

        this.show(this.index);
        this.queue();
      }

      disconnectedCallback() {
        this.stop();
        this.stopPointerWatch();
        window.clearTimeout(this.resumeTimer);
        window.clearTimeout(this.suppressTimer);
        window.clearTimeout(this.cancelTimer);
        this.desktopQuery?.removeEventListener('change', this.onDesktopChange);
      }

      onPointerDown(event) {
        if (this.drag) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (!this.beginDrag(event.clientX, event.clientY, event.target)) return;
        this.drag.pointerId = event.pointerId;
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerRelease);
        window.addEventListener('pointercancel', this.onPointerRelease);
      }

      onTouchStart(event) {
        if (this.drag || event.touches.length !== 1) return;
        const touch = event.touches[0];
        this.beginDrag(touch.clientX, touch.clientY, event.target);
      }

      onTouchMove(event) {
        if (!this.drag || !event.cancelable || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const deltaX = touch.clientX - this.drag.x;
        const deltaY = touch.clientY - this.drag.y;
        if (Math.abs(deltaX) < 10 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        event.preventDefault();
      }

      onTouchEnd(event) {
        if (!this.drag) return;
        const touch = event.changedTouches && event.changedTouches[0];
        this.stopPointerWatch();
        if (!touch) {
          this.drag = null;
          return;
        }
        if (this.finishDrag(touch.clientX, touch.clientY)) event.preventDefault();
      }

      beginDrag(clientX, clientY, target) {
        if (this.slides.length < 2) return false;
        if (target && target.closest && target.closest('.hero-rotator__dots, [data-hero-dot]')) return false;
        this.drag = {
          x: clientX,
          y: clientY,
          lastX: clientX,
          lastY: clientY,
          pointerId: null,
        };
        return true;
      }

      finishDrag(clientX, clientY) {
        if (!this.drag) return false;
        window.clearTimeout(this.cancelTimer);
        const deltaX = clientX - this.drag.x;
        const deltaY = clientY - this.drag.y;
        this.drag = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return false;
        this.show(this.index + (deltaX < 0 ? 1 : -1));
        this.suppressClick = true;
        window.clearTimeout(this.suppressTimer);
        this.suppressTimer = window.setTimeout(() => {
          this.suppressClick = false;
        }, 600);
        this.queue();
        window.clearTimeout(this.resumeTimer);
        // Touch focuses the slide link and may mouseenter, which pauses autoplay.
        // If that cleared the timer, start it again so the swipe is held for one interval.
        this.resumeTimer = window.setTimeout(() => {
          this.resumeTimer = 0;
          if (this.timer) return;
          this.queue();
        }, 700);
        return true;
      }

      stopPointerWatch() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerRelease);
        window.removeEventListener('pointercancel', this.onPointerRelease);
      }

      isTwoUp() {
        return this.slides.length > 1 && this.desktopQuery.matches;
      }

      show(index) {
        if (!this.slides.length) return;
        const count = this.slides.length;
        const next = (index + count) % count;
        this.index = next;
        const twoUp = this.isTwoUp();
        const peer = (next + 1) % count;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === next;
          const isPeer = twoUp && peer !== next && slideIndex === peer;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-peer', isPeer);
          if (active || isPeer) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });
        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === next ? 'true' : 'false');
        });
      }

      queue() {
        this.stop();
        // Reduced motion already disables the fade in CSS. Still advance so a
        // third slide is not stuck behind the first pair.
        if (this.interval < 1000 || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = 0;
      }
    }

    customElements.define('hero-rotator', HeroRotator);
  }

  } catch(e) { console.error(e); }
})();
})();
